// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"8690ccff","308":"9cf8b71b","392":"f1093083","552":"d67dd800","623":"86018e7e","682":"b94a0705","719":"47842d51","946":"4e76ee37"}[chunkId] + ".chunk.css";
};